import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { copyListFormStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsCopyListForm";
import { css } from "styled-components";

copyListFormStyles.cancelButton = mergeToNew(copyListFormStyles.cancelButton, {
    variant: "secondary"
});